<template>
  <b-nav-item
    v-if="showIndicator"
    class="maintenance-indicator mr-25"
    @click="reopenBanner"
    v-b-tooltip.hover
    :title="$t('Message.maintenanceTitle')"
  >
    <feather-icon icon="AlertTriangleIcon" size="21" class="text-warning" />
  </b-nav-item>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  name: "MaintenanceIndicator",
  computed: {
    ...mapGetters({
      bannerDismissed: "appConfig/getMaintenanceBannerDismissed",
      maintenanceEnabled: "appConfig/getMaintenanceEnabled",
    }),
    // Only show indicator when maintenance is enabled AND banner is dismissed
    showIndicator() {
      return this.maintenanceEnabled && this.bannerDismissed;
    },
  },
  methods: {
    reopenBanner() {
      // Clear the session storage and update Vuex state
      sessionStorage.removeItem("maintenanceBannerClosed");
      this.$store.commit("appConfig/SET_MAINTENANCE_BANNER_DISMISSED", false);
    },
  },
};
</script>

<style scoped>
.maintenance-indicator {
  cursor: pointer;
  transition: opacity 0.2s;
}

.maintenance-indicator:hover {
  opacity: 0.7;
}
</style>
